import css from 'styled-jsx/css';

export default css.global`.bg-sect {
  background-color: #f0f3f5;
  background-image: url("/static/img/pricing-bg.svg");
  background-size: 70%;
  background-position: center 100px;
  background-repeat: no-repeat;
  height: 370px;
}

.top-intro {
  margin: 8rem 0 7rem;
}

.pricing-sect {
  margin-top: -333px;
}

@media (min-width: 1023px) {
  .bg-sect {
    height: 680px;
  }

  .pricing-sect {
    margin-top: -575px;
  }

  .top-intro {
    margin: 8rem 0 3rem;
  }
}
`